import React from 'react';
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
  Paper, TextField, IconButton, Button, Box, Typography 
} from '@mui/material';
import { AddCircle as AddCircleIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { columns } from '../constants/options';

const AnalgesiaTable = ({ rows, updateRow, addRow, deleteRow }) => {
  const fields = [
    "assessment_time",
    "pulse_rate",
    "blood_pressure",
    "respiratory_rate",
    "spo2",
    "vas_score",
    "sedation",
    "rescue_analgesia_given",
    "staff_nurse"
  ];

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" sx={{ mb: 2, color: '#008080', fontWeight: 600 }}>
        Assessment Observations
      </Typography>
      <TableContainer component={Paper} elevation={2} sx={{ borderRadius: '8px', overflow: 'hidden' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              {columns.map((col) => (
                <TableCell key={col} sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>{col}</TableCell>
              ))}
              <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id} hover>
                {fields.map((field) => (
                  <TableCell key={field}>
                    <TextField
                      fullWidth
                      variant="standard"
                      type={field === "assessment_time" ? "time" : "text"}
                      value={row[field] || ""}
                      onChange={(e) => updateRow(row.id, field, e.target.value)}
                      InputProps={{ disableUnderline: true, sx: { fontSize: '0.9rem' } }}
                      sx={{ 
                        '& .MuiInputBase-root': {
                          borderBottom: '1px solid #e0e0e0',
                          '&:hover': { borderBottom: '1px solid #008080' }
                        }
                      }}
                    />
                  </TableCell>
                ))}
                <TableCell>
                  <IconButton
                    onClick={() => deleteRow(row.id)}
                    color="error"
                    disabled={rows.length <= 1}
                    size="small"
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Box sx={{ p: 2, backgroundColor: '#fafafa' }}>
          <Button
            variant="outlined"
            onClick={addRow}
            startIcon={<AddCircleIcon />}
            size="small"
            sx={{ color: '#008080', borderColor: '#008080' }}
          >
            Add Row
          </Button>
        </Box>
      </TableContainer>
    </Box>
  );
};

export default AnalgesiaTable;
